const isSidebarMenuItemActive = (to, pathname) =>
    // Detail/sub pages (e.g. /customers/:id, /settings/employees/:id) keep their section highlighted.
    pathname === to || (to !== "/" && pathname.startsWith(`${to}/`));

export default isSidebarMenuItemActive;
